import { render } from "./PaymentInfo.vue?vue&type=template&id=36b073d2&scoped=true"
import script from "./PaymentInfo.vue?vue&type=script&lang=js"
export * from "./PaymentInfo.vue?vue&type=script&lang=js"

import "./PaymentInfo.vue?vue&type=style&index=0&id=36b073d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b073d2"]])

export default __exports__